import React, { createContext, useContext, useState, Dispatch, SetStateAction, useMemo } from "react";
import {
    TableWrapper,
    WhatIsTable
} from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/db-providers.utils";
import { QueryItem } from "./components/add-queries-modal/add-queries-modal";

export type CurrentSelection = {
    schemas: number | null;
    entities?: number;
    timestamp?: number;
    data: any[];
    queries?: QueryItem[];
    hasError?: boolean;
    containerName?: string;
};

export type SourceInfo = {
    schemaType: TableWrapper;
    entityType: WhatIsTable;
    isAppAdapter: boolean;
    dbType: string;
    isCDC: boolean;
};

type SelectTablesContextProps = {
    currentSelection: CurrentSelection;
    setCurrentSelection: Dispatch<SetStateAction<CurrentSelection>>;
    sourceInfo?: SourceInfo;
    setSourceInfo?: Dispatch<SetStateAction<SourceInfo>>;
};

export const SelectTablesContext = createContext<SelectTablesContextProps>({
    currentSelection: { schemas: 0, entities: 0, data: [] },
    setCurrentSelection: () => {}
});

export const useSelectTables = () => useContext(SelectTablesContext);

type SelectTablesProviderProps = {
    children: JSX.Element;
};

export const currentSelectionInit = { schemas: null, data: [] };

export const sourceInfoInit: SourceInfo = {
    schemaType: TableWrapper.SCHEMA,
    entityType: WhatIsTable.TABLE,
    isAppAdapter: false,
    dbType: "",
    isCDC: false
};

const SelectTablesProvider = ({ children }: SelectTablesProviderProps) => {
    const [currentSelection, setCurrentSelection] = useState<CurrentSelection>(currentSelectionInit);
    const [sourceInfo, setSourceInfo] = useState<SourceInfo>(sourceInfoInit);

    const value = useMemo(
        () => ({
            currentSelection,
            setCurrentSelection,
            sourceInfo,
            setSourceInfo
        }),
        [currentSelection, setCurrentSelection, sourceInfo, setSourceInfo]
    );

    return <SelectTablesContext.Provider value={value}>{children}</SelectTablesContext.Provider>;
};

export default SelectTablesProvider;
